<template lang="pug">
.res-cancel-process
  transition-group(name="fade")
    .status.success(v-if="status===1" key="1")
      notification(:status="$t('reservation.status')[6].code" :msg="$t('reservation.status')[6].msg" :subMsg="$t('reservation.status')[6].subMsg")

    countdown-btn(v-if="status===1" key="2" :countdown="3" :copy="$t('btn.complete')")
  
</template>
<script>
import AlipayService from '@/services/AlipayService'
import { mapMutations, mapState, mapActions } from 'vuex'
import Notification from '@/components/wedgits/Notification'
import CountdownBtn from '@/components/wedgits/CountdownBtn'
export default {
  name: 'ResCancelProcess',
  components: {
    CountdownBtn,
    Notification,
  },
  props: {},
  data() {
    return {
      status: 0,
    }
  },
  computed: {
    ...mapState('app', ['user']),
  },
  created() {
    this.setPending(true)
    console.log(88888888888888, this.$route.query)
    this.ResCancel({
      userId: this.user.id,
      resId: this.$route.query.resId,
    }).then((res) => {
      console.log('cancel res:', res)
      setTimeout(() => {
        this.setPending(false)
      }, 500)
      this.status = 1
    })
    //console.log(this.$route.query)
  },
  methods: {
    ...mapMutations('app', ['setPending']),
    ...mapActions('app', ['ResCancel']),
    onMessage(data) {
      console.log('msg rec inside:', data)
    },
    onConfirm(e) {
      this.status = 1
    },
    onError() {
      console.log('error!!!!')
      this.status = 400
    },
  },
  mounted() {
    // let prod = process.env.NODE_ENV === 'production'
    // if (prod) {
    // } else {
    //   setTimeout(() => {
    //     this.addAdult({
    //       nickname: 'Victora',
    //       avatar: victora,
    //     })
    //     this.status = 1
    //     setTimeout(() => {
    //       this.$refs.check.animeIn()
    //     }, 200)
    //   }, 4000)
    // }
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.res-cancel-process
  position: absolute
  top: 0
  left: 0
  width: 100%
  height: 100%
  //padding: 0 pxToRem(30)
  color: black
  overflow: hidden
  .status
    position: absolute
    top: pxToRem(64)
    left: 0
    text-align: center
    width: 100%
    display: flex
    align-items: center
    justify-content: center
    flex-direction: column
  .pending

  .success
    .name-card
      position: relative
      width: pxToRem(702)
      height: pxToRem(489)
      margin: pxToRem(100) auto

.fade-enter-active, .fade-leave-active
  transition: all 0.5s
.fade-enter
  transform: translateX(50%)
  opacity: 0
.fade-leave-to
  transform: translateX(-50%)
  opacity: 0
</style>
